import React from "react";
import { useHistory } from "react-router-dom";

const VisibilityBoardsWidget = () => {
  const history = useHistory();

  const handleNavigation = (tab) => {
    history.push(`/admin/bulletin-board?tab=${encodeURIComponent(tab)}`);
  };

  const sections = [
    { line1: "ATHLETES AT TOP",   line2: "",               tab: "Boosted" },
    { line1: "YOUR FAN OPINION",  line2: "BOOSTS ATHLETE", tab: "Opinion" },
    { line1: "FAN MANAGERS AT TOP", line2: "",             tab: "Managers" },
  ];

  const ArrowPair = () => (
    <div style={{ display: "flex", alignItems: "center", gap: "2px" }}>
      <div style={{ width: 0, height: 0, borderTop: "10px solid transparent", borderBottom: "10px solid transparent", borderLeft: "13px solid #e00" }} />
      <div style={{ width: 0, height: 0, borderTop: "10px solid transparent", borderBottom: "10px solid transparent", borderLeft: "13px solid #e00" }} />
    </div>
  );

  return (
    <div style={{ width: "100%", maxWidth: "360px", margin: "0 auto", display: "flex", flexDirection: "column", height: "100%" }}>

      <div style={{
        border: "3px solid #222",
        borderRadius: "14px",
        overflow: "hidden",
        width: "100%",
        backgroundColor: "#fff",
        boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
        display: "flex",
        flexDirection: "column",
        height: "100%",
        justifyContent: "space-between",
      }}>
        {/* Header */}
        <div style={{ padding: "12px 14px" }}>
          <div style={{ border: "3px solid #e00", borderRadius: "8px", padding: "12px 10px", textAlign: "center" }}>
            <div style={{ fontSize: "20px", fontWeight: "800", color: "#4a5568", letterSpacing: "1.5px", lineHeight: 1.2 }}>
              VISIBILITYBOARDS
            </div>
          </div>
        </div>

      {/* Sections */}
      {sections.map((section, i) => (
        <div
          key={i}
          onClick={() => handleNavigation(section.tab)}
          style={{
            borderTop: "2px solid #bbb",
            padding: "12px 16px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            cursor: "pointer",
            backgroundColor: "#fff",
          }}
          onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#f5f5f5"}
          onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "#fff"}
        >
          {/* Left: left-aligned, both lines red */}
          <div>
            <div style={{ fontSize: "16px", fontWeight: "800", color: "#e00", lineHeight: 1.3 }}>
              {section.line1}
            </div>
            <div style={{ fontSize: "16px", fontWeight: "800", color: "#3b5bdb", lineHeight: 1.3 }}>
              {section.line2}
            </div>
          </div>

          {/* Right: VIEW + arrows on top, BOARD below */}
          <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", minWidth: 80 }}>
            <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
              <span style={{ fontSize: "15px", fontWeight: "800", color: "#222" }}>VIEW</span>
              <ArrowPair />
            </div>
            <span style={{ fontSize: "15px", fontWeight: "800", color: "#222" }}>BOARD</span>
          </div>
        </div>
      ))}

      {/* Footer */}
      <div style={{ borderTop: "2px solid #bbb", padding: "12px", textAlign: "center" }}>
        <span style={{ fontSize: "16px", fontWeight: "800", color: "#e00" }}>CLICK </span>
        <span style={{ fontSize: "16px", fontWeight: "800", color: "#222" }}>ARROW</span>
      </div>
    </div>
    </div>
  );
};

export default VisibilityBoardsWidget;
